.metricGradeRangeSelect {
  padding: var(--gap-small) var(--gap-regular);
  :global(.rc-slider-mark) {
    left: 8% !important;
  }
}
